module.exports = __webpack_public_path__ + "img/footer-1-4.d135254b.png";